// extracted by mini-css-extract-plugin
module.exports = {"home":"Index_home_1G9HZ"};